(function () {
  if (window.MaterialAdvisor && window.MaterialAdvisor.initAll) {
    window.MaterialAdvisor.initAll();
    return;
  }

  var STORAGE_PREFIX = 'material-advisor-state:v4:';

  var STEPS = [];
  var ALL_STEPS = [];

  function buildSteps(products) {
    var applications = productValues(products, 'applications');
    var thicknesses = productValues(products, 'thicknesses').sort(sortThickness);
    var colors = productValues(products, 'colors');
    var transparencies = productValues(products, 'transparency');
    var finishes = productValues(products, 'finish');
    var laserOptions = [];
    if (products.some(function (product) { return product.co2Laser === true; })) {
      laserOptions.push({ id: 'co2', label: 'CO2-laser', description: '' });
    }
    if (products.some(function (product) { return product.diodeLaser === true; })) {
      laserOptions.push({ id: 'diode', label: 'Diodelaser', description: '' });
    }

    var knownOptions = [
      { id: 'application', label: 'Toepassing' },
      { id: 'thickness', label: 'Dikte' },
      { id: 'color', label: 'Kleur' },
      { id: 'transparency', label: 'Doorzichtigheid' },
      { id: 'laser', label: 'Lasertype' },
      { id: 'finish', label: 'Afwerking' }
    ].filter(function (option) {
      if (option.id === 'application') return applications.length;
      if (option.id === 'thickness') return thicknesses.length;
      if (option.id === 'color') return colors.length;
      if (option.id === 'transparency') return transparencies.length;
      if (option.id === 'laser') return laserOptions.length;
      if (option.id === 'finish') return finishes.length;
      return false;
    }).map(function (option) {
      return { id: option.id, label: option.label, description: '' };
    });

    return [
      {
        key: 'known',
        type: 'multi',
        title: 'Wat weet je al over je project?',
        shortTitle: 'Bekend',
        description: 'Kies alles wat al vaststaat. Je krijgt alleen daar vervolgvragen over.',
        options: knownOptions
      },
      {
        key: 'application',
        type: 'multi',
        title: 'Wat ga je maken?',
        shortTitle: 'Toepassing',
        options: applications.map(function (application) {
          return { id: application, label: application, description: '' };
        })
      },
      {
        key: 'laser',
        type: 'multi',
        title: 'Welke laser gebruik je?',
        shortTitle: 'Laser',
        options: laserOptions
      },
      {
        key: 'color',
        type: 'multi',
        title: 'Welke kleur zoek je?',
        shortTitle: 'Kleur',
        options: valueOptions(colors)
      },
      {
        key: 'transparency',
        type: 'multi',
        title: 'Welke doorzichtigheid zoek je?',
        shortTitle: 'Doorzichtigheid',
        options: valueOptions(transparencies)
      },
      {
        key: 'thickness',
        type: 'multi',
        title: 'Welke dikte zoek je?',
        shortTitle: 'Dikte',
        options: valueOptions(thicknesses)
      },
      {
        key: 'finish',
        type: 'multi',
        title: 'Welke afwerking wil je?',
        shortTitle: 'Afwerking',
        options: valueOptions(finishes)
      }
    ];
  }

  function productValues(products, key) {
    return uniqueList(products.reduce(function (all, product) {
      return all.concat(product[key] || []);
    }, [])).sort(function (a, b) { return a.localeCompare(b, 'nl'); });
  }

  function valueOptions(values) {
    return values.map(function (value) {
      return { id: value, label: value, description: '' };
    });
  }

  function activeSteps(state) {
    var known = Array.isArray(state.known) ? state.known : [];
    return ALL_STEPS.filter(function (step, index) {
      return index === 0 || known.indexOf(step.key) >= 0;
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-material-advisor]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  function initRoot(root) {
    if (!root || root.dataset.materialAdvisorReady === 'true') return;

    var dataNode = root.querySelector('script[type="application/json"]');
    var app = root.querySelector('[data-material-advisor-app]');
    if (!dataNode || !app) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      app.innerHTML = renderNotice('De materiaaldata kon niet worden gelezen.');
      return;
    }

    var products = uniqueProducts((data.products || []).map(normalizeProduct).filter(Boolean));
    ALL_STEPS = buildSteps(products);
    var stats = buildStats(products);
    var storageKey = STORAGE_PREFIX + (data.sectionId || root.id || 'default');
    var state = Object.assign(createDefaultState(), loadState(storageKey) || {});
    STEPS = activeSteps(state);
    var currentStep = state.currentStep || 0;

    root.dataset.materialAdvisorReady = 'true';

    root.addEventListener('click', function (event) {
      var actionNode = event.target.closest('[data-ma-action]');
      if (!actionNode || !root.contains(actionNode)) return;

      var action = actionNode.dataset.maAction;

      if (action === 'option') {
        updateSelection(state, actionNode.dataset.key, actionNode.dataset.value);
        if (actionNode.dataset.key === 'known') {
          ALL_STEPS.slice(1).forEach(function (step) {
            if (state.known.indexOf(step.key) < 0) state[step.key] = [];
          });
          STEPS = activeSteps(state);
        }
        saveState(storageKey, state, currentStep);
        renderStep();
      }

      if (action === 'next') {
        if (!hasSelection(state, STEPS[currentStep])) return;
        currentStep += 1;
        saveState(storageKey, state, currentStep);
        if (currentStep >= STEPS.length) {
          renderResults();
        } else {
          renderStep();
        }
      }

      if (action === 'back') {
        if (currentStep >= STEPS.length) {
          currentStep = STEPS.length - 1;
          if (STEPS[currentStep]) state[STEPS[currentStep].key] = [];
        } else {
          if (currentStep > 0 && STEPS[currentStep]) state[STEPS[currentStep].key] = [];
          currentStep = Math.max(0, currentStep - 1);
        }
        saveState(storageKey, state, currentStep);
        renderStep();
      }

      if (action === 'restart') {
        state = createDefaultState();
        STEPS = activeSteps(state);
        currentStep = 0;
        saveState(storageKey, state, currentStep);
        renderStep();
      }

      if (action === 'jump') {
        currentStep = Number(actionNode.dataset.stepIndex || 0);
        saveState(storageKey, state, currentStep);
        renderStep();
      }
    });

    if (!products.length) {
      app.innerHTML = renderNotice('Er zijn nog geen materialen gevonden in de gekozen collectie.');
      return;
    }

    if (currentStep >= STEPS.length) {
      renderResults();
    } else {
      renderStep();
    }

    function renderStep() {
      var step = STEPS[currentStep];
      var scored = scoreProducts(products, state, stats);
      var possibleCount = scored.filter(function (item) { return item.score >= 52; }).length || scored.length;
      var progress = Math.round(((currentStep + 1) / STEPS.length) * 100);
      var canContinue = hasSelection(state, step);
      var visibleOptions = step.options.map(function (option) {
        return {
          option: option,
          count: step.key === 'known' ? null : previewCount(products, stats, state, step, option.id)
        };
      }).filter(function (item) {
        return item.count === null || item.count > 0;
      });

      app.innerHTML = [
        '<div class="ma-shell' + (currentStep === 0 ? ' ma-shell--start' : '') + '">',
          currentStep > 0 ? renderProgress(currentStep, progress, possibleCount) : '',
          '<div class="ma-step">',
            '<div class="ma-step__copy">',
              currentStep > 0 ? '<p class="ma-step__kicker">Stap ' + (currentStep + 1) + ' van ' + STEPS.length + '</p>' : '',
              '<h3 class="ma-step__title" tabindex="-1" data-ma-focus>' + escapeHtml(step.title) + '</h3>',
              step.description ? '<p class="ma-step__description">' + escapeHtml(step.description) + '</p>' : '',
            '</div>',
            '<div class="ma-options ma-options--' + escapeHtml(step.type) + '" role="group" aria-label="' + escapeHtml(step.title) + '">',
              visibleOptions.map(function (item) {
                return renderOption(step, item.option, item.count);
              }).join(''),
            '</div>',
          '</div>',
          '<div class="ma-nav">',
            currentStep > 0
              ? '<button type="button" class="ma-button ma-button--secondary" data-ma-action="back">Terug</button>'
              : '<span></span>',
            '<button type="button" class="ma-button ma-button--primary" data-ma-action="next"' + (canContinue ? '' : ' disabled') + '>Volgende</button>',
          '</div>',
        '</div>'
      ].join('');

      if (currentStep > 0) focusStepTitle(app);
      track('material_advisor_step', { step: currentStep + 1, key: step.key });
    }

    function renderResults() {
      var scored = scoreProducts(products, state, stats);
      var limit = Math.max(3, Number(data.resultsLimit || 9));
      var shown = scored.slice(0, limit);
      var summary = renderSummary(state);

      app.innerHTML = [
        '<div class="ma-shell ma-shell--results">',
          '<div class="ma-results-head">',
            '<div>',
              '<p class="ma-step__kicker">Advies</p>',
              '<h3 class="ma-step__title" tabindex="-1" data-ma-focus>Beste materialen voor je selectie</h3>',
            '</div>',
            '<button type="button" class="ma-button ma-button--secondary" data-ma-action="restart">Opnieuw starten</button>',
          '</div>',
          summary,
          shown.length
            ? '<div class="ma-result-grid ma-result-grid--top">' + shown.map(function (item) {
                return renderResultCard(item);
              }).join('') + '</div>'
            : renderNotice('Geen sterke match gevonden. Pas een keuze aan om breder te zoeken.'),
          '<div class="ma-nav ma-nav--results">',
            '<button type="button" class="ma-button ma-button--secondary" data-ma-action="back">Laatste keuze aanpassen</button>',
            '<button type="button" class="ma-button ma-button--primary" data-ma-action="restart">Nieuwe keuzehulp</button>',
          '</div>',
        '</div>'
      ].join('');

      focusStepTitle(app);
      track('material_advisor_results', { top_handle: shown[0] && shown[0].product.handle, result_count: shown.length });
    }

    function renderOption(step, option, count) {
      var selected = isSelected(state, step, option.id);
      return [
        '<button type="button"',
          ' class="ma-option' + (selected ? ' is-selected' : '') + '"',
          ' data-ma-action="option"',
          ' data-key="' + escapeAttr(step.key) + '"',
          ' data-value="' + escapeAttr(option.id) + '"',
          ' aria-pressed="' + (selected ? 'true' : 'false') + '">',
          '<span class="ma-option__body">',
            '<span class="ma-option__label">' + escapeHtml(option.label) + '</span>',
            '<span class="ma-option__description">' + escapeHtml(option.description || '') + '</span>',
          '</span>',
          count === null ? '' : '<span class="ma-option__count">' + count + '</span>',
        '</button>'
      ].join('');
    }

    function renderSummary(currentState) {
      return [
        '<div class="ma-summary" aria-label="Gemaakte keuzes">',
          STEPS.slice(1).map(function (step, summaryIndex) {
            var index = summaryIndex + 1;
            return [
              '<button type="button" class="ma-summary__item" data-ma-action="jump" data-step-index="' + index + '">',
                '<span>' + escapeHtml(step.shortTitle) + '</span>',
                '<strong>' + escapeHtml(selectionLabel(step, currentState[step.key])) + '</strong>',
              '</button>'
            ].join('');
          }).join(''),
        '</div>'
      ].join('');
    }

    function renderResultCard(item) {
      var product = item.product;
      var metas = resultMeta(product, state).slice(0, 4);
      var image = product.image
        ? '<img src="' + escapeAttr(product.image) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="720" height="720">'
        : '<div class="ma-image-placeholder">' + escapeHtml(product.familyLabel) + '</div>';
      var price = data.showPrices && product.priceMin
        ? '<p class="ma-result-card__price">Vanaf ' + escapeHtml(formatMoney(product.priceMin, data.locale, data.currency)) + '</p>'
        : '';

      return [
        '<a class="ma-result-card ma-result-card--prominent" href="' + escapeAttr(product.url) + '">',
          '<div class="ma-result-card__media">' + image + '</div>',
          '<div class="ma-result-card__body">',
            '<h4 class="ma-result-card__title">' + escapeHtml(product.title) + '</h4>',
            '<div class="ma-tags">' + metas.map(function (meta) {
              return '<span>' + escapeHtml(meta) + '</span>';
            }).join('') + '</div>',
            price,
            '<span class="ma-result-card__cta">' + escapeHtml(data.productButtonLabel || 'Bekijk materiaal') + '</span>',
          '</div>',
        '</a>'
      ].join('');
    }
  }

  function createDefaultState() {
    return {
      known: [],
      application: [],
      laser: [],
      color: [],
      transparency: [],
      thickness: [],
      finish: []
    };
  }

  function updateSelection(state, key, value) {
    var step = findStep(key);
    if (!step) return;

    if (step.type === 'multi') {
      var current = Array.isArray(state[key]) ? state[key].slice() : [];
      if (value === 'any') {
        state[key] = current.indexOf('any') >= 0 ? [] : ['any'];
        return;
      }
      current = current.filter(function (item) { return item !== 'any'; });
      var index = current.indexOf(value);
      if (index >= 0) {
        current.splice(index, 1);
      } else {
        current.push(value);
      }
      state[key] = current;
      return;
    }

    state[key] = state[key] === value ? '' : value;
  }

  function hasSelection(state, step) {
    if (!step) return false;
    if (step.type === 'multi') return Array.isArray(state[step.key]) && state[step.key].length > 0;
    return Boolean(state[step.key]);
  }

  function isSelected(state, step, value) {
    var current = state[step.key];
    if (step.type === 'multi') return Array.isArray(current) && current.indexOf(value) >= 0;
    return current === value;
  }

  function selectionLabel(step, value) {
    if (step.type === 'multi') {
      if (!Array.isArray(value) || !value.length) return 'Niet gekozen';
      if (value.indexOf('any') >= 0) return 'Geen voorkeur';
      return value.map(function (id) { return optionLabel(step, id); }).join(', ');
    }
    return value ? optionLabel(step, value) : 'Niet gekozen';
  }

  function optionLabel(step, id) {
    var option = (step.options || []).filter(function (item) { return item.id === id; })[0];
    return option ? option.label : id;
  }

  function findStep(key) {
    return ALL_STEPS.filter(function (step) { return step.key === key; })[0];
  }

  function normalizeProduct(raw) {
    if (!raw || !raw.title) return null;

    var metafields = raw.metafields || {};
    var thicknesses = uniqueList(
      normalizeList(metafields.thickness)
        .concat(optionValues(raw, ['thickness', 'dikte']))
        .concat(prefixedTags(raw.tags, ['thickness', 'dikte']))
    ).sort(sortThickness);
    var colors = uniqueList(normalizeList(metafields.color));
    var applications = uniqueList(normalizeList(metafields.applications));
    var features = uniqueList(
      normalizeList(metafields.features)
        .concat(prefixedTags(raw.tags, ['feature', 'eigenschap', 'special']))
    );
    var searchable = [
      raw.title,
      raw.handle,
      raw.description,
      normalizeList(metafields.material).join(' '),
      normalizeList(metafields.finish).join(' '),
      normalizeList(metafields.transparency).join(' '),
      features.join(' '),
      colors.join(' '),
      (raw.tags || []).join(' ')
    ].join(' ').toLowerCase();

    var family = inferFamily(searchable);
    var finish = uniqueList(normalizeList(metafields.finish));
    var transparency = uniqueList(normalizeList(metafields.transparency));

    return {
      id: raw.id,
      handle: raw.handle || '',
      title: raw.title,
      url: raw.url || ('/products/' + raw.handle),
      image: normalizeImageUrl(raw.image),
      available: raw.available !== false,
      priceMin: Number(raw.priceMin || 0),
      priceMax: Number(raw.priceMax || raw.priceMin || 0),
      description: raw.description || '',
      tags: raw.tags || [],
      thicknesses: thicknesses,
      thicknessNumbers: thicknesses.map(parseThickness).filter(isFiniteNumber),
      colors: colors,
      finish: finish,
      transparency: transparency,
      applications: applications,
      co2Laser: normalizeBoolean(metafields.co2Laser),
      diodeLaser: normalizeBoolean(metafields.diodeLaser),
      features: features,
      family: family.key,
      familyLabel: family.label,
      text: searchable
    };
  }

  function uniqueProducts(products) {
    var seen = {};
    return products.filter(function (product) {
      var key = product.handle || product.id || product.title;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function buildStats(products) {
    var prices = products.map(function (product) { return product.priceMin; }).filter(function (price) { return price > 0; });
    var min = prices.length ? Math.min.apply(Math, prices) : 0;
    var max = prices.length ? Math.max.apply(Math, prices) : 0;
    return { minPrice: min, maxPrice: max };
  }

  function optionValues(raw, terms) {
    var options = raw.options || [];
    var values = [];
    options.forEach(function (option) {
      var name = String(option.name || '').toLowerCase();
      if (terms.some(function (term) { return name.indexOf(term) >= 0; })) {
        values = values.concat(normalizeList(option.values));
      }
    });
    return values;
  }

  function prefixedTags(tags, prefixes) {
    var values = [];
    (tags || []).forEach(function (tag) {
      var text = String(tag || '');
      var lower = text.toLowerCase();
      prefixes.forEach(function (prefix) {
        if (lower.indexOf(prefix + ':') === 0 || lower.indexOf(prefix + '=') === 0) {
          values.push(text.slice(prefix.length + 1).trim());
        }
      });
    });
    return values;
  }

  function normalizeList(value) {
    if (value === null || value === undefined || value === '') return [];
    if (Array.isArray(value)) {
      return value.reduce(function (all, item) {
        if (item === null || item === undefined || item === '') return all;
        if (typeof item === 'object') return all.concat(normalizeList(item));
        var clean = String(item).trim();
        return clean ? all.concat(clean) : all;
      }, []);
    }
    if (typeof value === 'object') {
      if (value.name) return [String(value.name).trim()];
      if (value.label) return [String(value.label).trim()];
      return [];
    }
    return String(value)
      .split(/[;|]/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function normalizeBoolean(value) {
    if (value === true || value === false) return value;
    if (String(value).toLowerCase() === 'true') return true;
    if (String(value).toLowerCase() === 'false') return false;
    return null;
  }

  function uniqueList(list) {
    var seen = {};
    var output = [];
    list.forEach(function (item) {
      var clean = String(item || '').trim().replace(/\\/g, '');
      var key = clean.toLowerCase();
      if (!clean || seen[key]) return;
      seen[key] = true;
      output.push(clean);
    });
    return output;
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    return url;
  }

  function inferFamily(text) {
    if (hasAny(text, ['eva', 'foam', 'schuim', 'rubber', 'vilt', 'felt', 'fibernyl'])) return { key: 'flexible', label: 'Flexibel materiaal' };
    if (hasAny(text, ['mdf', 'hdf'])) return { key: 'mdf', label: 'MDF/HDF' };
    if (hasAny(text, ['karton', 'cardboard', 'papier', 'paper'])) return { key: 'paper', label: 'Karton/papier' };
    if (hasAny(text, ['bamboe', 'bamboo', 'multiplex', 'plywood', 'triplex', 'veneer', 'fineer', 'hout', 'wood', 'eiken', 'oak', 'mahonie', 'notenhout', 'walnut', 'poplar', 'birch', 'berken'])) return { key: 'wood', label: 'Hout' };
    if (hasAny(text, ['acrylic', 'acrylaat', 'pmma', 'plexiglass', 'plexi'])) return { key: 'acrylic', label: 'Acrylaat' };
    if (hasAny(text, ['aluminium', 'metal', 'metallic', 'dibond'])) return { key: 'metal', label: 'Metaal look' };
    if (hasAny(text, ['bio', 'biopanel', 'recycled'])) return { key: 'bio', label: 'Bio-based' };
    return { key: 'general', label: 'Plaatmateriaal' };
  }

  function scoreProducts(products, state, stats) {
    return products.filter(function (product) {
      if (selectionHasValues(state.application) && !selectionHasMatch(product.applications, state.application)) return false;
      if (selectionHasValues(state.color) && !selectionHasMatch(product.colors, state.color)) return false;
      if (selectionHasValues(state.transparency) && !selectionHasMatch(product.transparency, state.transparency)) return false;
      if (selectionHasValues(state.finish) && !selectionHasMatch(product.finish, state.finish)) return false;
      if (selectionHasValues(state.thickness) && !selectionHasThickness(product.thicknesses, state.thickness)) return false;
      if (selectionHasValues(state.laser) && !selectionHasLaser(product, state.laser)) return false;
      return true;
    }).map(function (product) {
      var result = scoreProduct(product, state, stats);
      return {
        product: product,
        score: result.score,
        match: Math.max(32, Math.min(99, Math.round(result.score))),
        reasons: result.reasons.length ? result.reasons : ['Dit materiaal blijft een mogelijke optie voor je selectie.']
      };
    }).sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return (a.product.priceMin || 999999) - (b.product.priceMin || 999999);
    });
  }

  function scoreProduct(product, state, stats) {
    var score = product.available ? 30 : 18;
    var reasons = [];

    score += selectionScore(product.applications, state.application, 'Toepassing: ', reasons, 42);
    score += selectionScore(product.colors, state.color, 'Kleur: ', reasons, 18);
    score += selectionScore(product.transparency, state.transparency, 'Doorzichtigheid: ', reasons, 18);
    score += selectionScore(product.finish, state.finish, 'Afwerking: ', reasons, 16);
    score += selectionThicknessScore(product.thicknesses, state.thickness, reasons);
    score += selectionLaserScore(product, state.laser, reasons);

    if (product.available) addReason(reasons, 'Beschikbaar in de materiaalcollectie.');

    return { score: score, reasons: reasons.slice(0, 4) };
  }

  function scoreApplication(product, application, reasons) {
    if (!application) return 0;
    if (hasApplication(product, application)) {
      addReason(reasons, 'Op de materiaalpagina geselecteerd voor ' + application + '.');
      return 42;
    }
    return -100;
  }

  function scoreLaser(product, laser, reasons) {
    if (!laser || laser === 'any') return 0;
    if (laser === 'co2' && product.co2Laser === true) {
      addReason(reasons, 'Geschikt voor een CO₂-laser.');
      return 18;
    }
    if (laser === 'diode' && product.diodeLaser === true) {
      addReason(reasons, 'Geschikt voor een diodelaser.');
      return 18;
    }
    return -100;
  }

  function hasApplication(product, application) {
    var target = String(application || '').toLowerCase();
    return (product.applications || []).some(function (item) {
      return String(item || '').toLowerCase() === target;
    });
  }

  function scoreLook(product, look, reasons) {
    if (!look || look === 'any') return 0;

    if (look === 'white') {
      if (hasAny(product.colors.join(' ').toLowerCase(), ['white', 'wit']) || hasAny(product.title.toLowerCase(), ['white', 'wit'])) {
        addReason(reasons, 'Beschikbaar in wit.');
        return 24;
      }
      return -16;
    }

    if (look === 'black') {
      if (hasAny(product.colors.join(' ').toLowerCase(), ['black', 'zwart']) || hasAny(product.title.toLowerCase(), ['black', 'zwart'])) {
        addReason(reasons, 'Beschikbaar in zwart.');
        return 24;
      }
      return -16;
    }

    if (look === 'clear') {
      if (hasTransparency(product, ['clear'])) {
        addReason(reasons, 'De uitstraling is helder transparant.');
        return 24;
      }
      if (isTransparent(product)) return 12;
      return -16;
    }

    if (look === 'opal') {
      if (hasTransparency(product, ['semi-transparent']) || hasAny(product.text, ['opal', 'opaal', 'diffuse'])) {
        addReason(reasons, 'Geeft een zachte lichtdoorlatende look.');
        return 24;
      }
      if (isTransparent(product)) return 8;
      return -8;
    }

    if (look === 'color') {
      if (hasAny(product.colors.join(' ').toLowerCase(), ['red', 'blue', 'green', 'yellow', 'orange', 'pink', 'purple', 'rood', 'blauw', 'groen', 'geel']) || hasAny(product.text, ['colored', 'gekleurd', 'fluor'])) {
        addReason(reasons, 'Beschikbaar in opvallende kleuren.');
        return 22;
      }
      return 0;
    }

    if (look === 'blackwhite') {
      if (hasAny(product.colors.join(' ').toLowerCase(), ['black', 'white', 'zwart', 'wit']) || hasAny(product.title.toLowerCase(), ['black', 'white', 'zwart', 'wit'])) {
        addReason(reasons, 'Past bij een zwart-witte of neutrale uitstraling.');
        return 22;
      }
      return 0;
    }

    if (look === 'wood') {
      if (inFamily(product, ['wood', 'bio']) || hasAny(product.text, ['wood', 'hout', 'bamboo', 'bamboe', 'veneer', 'fineer'])) {
        addReason(reasons, 'Geeft een natuurlijke houtachtige uitstraling.');
        return product.family === 'paper' ? 14 : 24;
      }
      return -10;
    }

    if (look === 'mirror') {
      if (hasAny(product.text, ['mirror', 'spiegel', 'metallic', 'gold', 'silver', 'aluminium'])) {
        addReason(reasons, 'Heeft een spiegelende of metallic uitstraling.');
        return 24;
      }
      return -6;
    }

    return 0;
  }

  function matchesLook(product, look) {
    return scoreLook(product, look, []) > 0;
  }

  function matchesThickness(product, thickness) {
    if (!product.thicknessNumbers.length) return false;
    if (thickness === 'thin') return product.thicknessNumbers.some(function (value) { return value <= 2; });
    if (thickness === 'standard') return product.thicknessNumbers.some(function (value) { return value >= 2.5 && value <= 3.5; });
    if (thickness === 'rigid') return product.thicknessNumbers.some(function (value) { return value >= 4 && value <= 6; });
    if (thickness === 'thick') return product.thicknessNumbers.some(function (value) { return value >= 8; });
    return true;
  }

  function scoreThickness(product, thickness, reasons) {
    if (!thickness || thickness === 'any') return 0;
    if (!product.thicknessNumbers.length) return 2;

    var match = false;
    if (thickness === 'thin') match = product.thicknessNumbers.some(function (value) { return value <= 2; });
    if (thickness === 'standard') match = product.thicknessNumbers.some(function (value) { return value >= 2.5 && value <= 3.5; });
    if (thickness === 'rigid') match = product.thicknessNumbers.some(function (value) { return value >= 4 && value <= 6; });
    if (thickness === 'thick') match = product.thicknessNumbers.some(function (value) { return value >= 8; });

    if (match) {
      addReason(reasons, 'Beschikbaar in de gewenste dikterange.');
      return 18;
    }

    return -10;
  }

  function scoreFinish(product, finish, reasons) {
    if (!finish || finish === 'any') return 0;
    var finishText = product.finish.join(' ').toLowerCase() + ' ' + product.text;

    if (finish === 'matte' && hasAny(finishText, ['matte', 'mat ', 'frosted'])) {
      addReason(reasons, 'Heeft een matte of rustige afwerking.');
      return 16;
    }
    if (finish === 'gloss' && hasAny(finishText, ['shine', 'gloss', 'glans', 'polished', 'clear'])) {
      addReason(reasons, 'Sluit aan op een glanzende afwerking.');
      return 16;
    }
    if (finish === 'satin' && hasAny(finishText, ['satin', 'satijn'])) {
      addReason(reasons, 'Heeft een satin uitstraling.');
      return 16;
    }
    if (finish === 'natural' && (inFamily(product, ['wood', 'paper', 'bio']) || hasAny(finishText, ['natural', 'natuurlijk', 'wood', 'hout']))) {
      addReason(reasons, 'Heeft een natuurlijke afwerking.');
      return 16;
    }
    if (finish === 'mirror' && hasAny(finishText, ['mirror', 'spiegel'])) {
      addReason(reasons, 'Heeft een spiegelende afwerking.');
      return 16;
    }

    return -3;
  }

  function selectionHasValues(values) {
    return Array.isArray(values) && values.length > 0;
  }

  function selectionNormalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function selectionMatches(productValuesList, selectedValues) {
    var selected = (selectedValues || []).map(selectionNormalize);
    return (productValuesList || []).filter(function (value) {
      return selected.indexOf(selectionNormalize(value)) >= 0;
    });
  }

  function selectionHasMatch(productValuesList, selectedValues) {
    return selectionMatches(productValuesList, selectedValues).length > 0;
  }

  function selectionScore(productValuesList, selectedValues, prefix, reasons, points) {
    if (!selectionHasValues(selectedValues)) return 0;
    var matches = selectionMatches(productValuesList, selectedValues);
    if (!matches.length) return -100;
    addReason(reasons, prefix + matches.join(', ') + '.');
    return points;
  }

  function selectionHasThickness(productThicknesses, selectedThicknesses) {
    return (productThicknesses || []).some(function (productValue) {
      return (selectedThicknesses || []).some(function (selectedValue) {
        var productNumber = parseThickness(productValue);
        var selectedNumber = parseThickness(selectedValue);
        if (isFiniteNumber(productNumber) && isFiniteNumber(selectedNumber)) return productNumber === selectedNumber;
        return selectionNormalize(productValue) === selectionNormalize(selectedValue);
      });
    });
  }

  function selectionThicknessScore(productThicknesses, selectedThicknesses, reasons) {
    if (!selectionHasValues(selectedThicknesses)) return 0;
    if (!selectionHasThickness(productThicknesses, selectedThicknesses)) return -100;
    var matches = (productThicknesses || []).filter(function (value) {
      return selectionHasThickness([value], selectedThicknesses);
    });
    addReason(reasons, 'Dikte: ' + matches.join(', ') + '.');
    return 18;
  }

  function selectionHasLaser(product, selectedLasers) {
    return selectedLasers.some(function (laser) {
      return (laser === 'co2' && product.co2Laser === true) || (laser === 'diode' && product.diodeLaser === true);
    });
  }

  function selectionLaserScore(product, selectedLasers, reasons) {
    if (!selectionHasValues(selectedLasers)) return 0;
    if (!selectionHasLaser(product, selectedLasers)) return -100;
    var matches = [];
    if (selectedLasers.indexOf('co2') >= 0 && product.co2Laser === true) matches.push('CO2-laser');
    if (selectedLasers.indexOf('diode') >= 0 && product.diodeLaser === true) matches.push('Diodelaser');
    addReason(reasons, 'Lasertype: ' + matches.join(', ') + '.');
    return 18;
  }

  function previewCount(products, stats, state, step, optionId) {
    var preview = cloneState(state);
    if (step.type === 'multi') {
      if (optionId === 'any') {
        preview[step.key] = ['any'];
      } else {
        preview[step.key] = [optionId];
      }
    } else {
      preview[step.key] = optionId;
    }
    var scored = scoreProducts(products, preview, stats);
    return scored.filter(function (item) { return item.score >= 52; }).length || scored.length;
  }

  function resultMeta(product, state) {
    var meta = [product.familyLabel];
    var selectedThicknesses = product.thicknesses.filter(function (value) {
      return state && selectionHasValues(state.thickness) && selectionHasThickness([value], state.thickness);
    });
    if (selectedThicknesses.length) {
      meta.push(selectedThicknesses.join(', '));
    } else if (product.thicknesses.length) {
      meta.push(product.thicknesses.slice(0, 4).join(', '));
    }
    if (product.colors.length) meta.push(product.colors.length === 1 ? product.colors[0] : product.colors.length + ' kleuren');
    if (product.transparency.length) meta.push(product.transparency[0]);
    if (product.finish.length) meta.push(product.finish[0]);
    return uniqueList(meta);
  }

  function renderProgress(stepIndex, progress, count) {
    return [
      '<div class="ma-progress" aria-label="Voortgang">',
        '<div class="ma-progress__bar"><span style="width:' + progress + '%"></span></div>',
        '<div class="ma-progress__meta">',
          '<span>' + count + ' mogelijke matches</span>',
          '<span>' + (stepIndex + 1) + '/' + STEPS.length + '</span>',
        '</div>',
      '</div>'
    ].join('');
  }

  function renderNotice(message) {
    return '<div class="ma-notice">' + escapeHtml(message) + '</div>';
  }

  function cloneState(state) {
    return {
      known: Array.isArray(state.known) ? state.known.slice() : [],
      application: Array.isArray(state.application) ? state.application.slice() : [],
      laser: Array.isArray(state.laser) ? state.laser.slice() : [],
      color: Array.isArray(state.color) ? state.color.slice() : [],
      transparency: Array.isArray(state.transparency) ? state.transparency.slice() : [],
      thickness: Array.isArray(state.thickness) ? state.thickness.slice() : [],
      finish: Array.isArray(state.finish) ? state.finish.slice() : []
    };
  }

  function loadState(key) {
    try {
      var stored = window.sessionStorage.getItem(key);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  function saveState(key, state, currentStep) {
    try {
      var payload = cloneState(state);
      payload.currentStep = currentStep;
      window.sessionStorage.setItem(key, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function formatMoney(cents, locale, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || 'nl-NL', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(value);
    } catch (error) {
      return 'EUR ' + value.toFixed(2);
    }
  }

  function addReason(reasons, reason) {
    if (reasons.indexOf(reason) < 0) reasons.push(reason);
  }

  function inFamily(product, families) {
    return families.indexOf(product.family) >= 0;
  }

  function hasAny(text, terms) {
    var haystack = String(text || '').toLowerCase();
    return terms.some(function (term) {
      return haystack.indexOf(term) >= 0;
    });
  }

  function hasTransparency(product, terms) {
    var text = product.transparency.join(' ').toLowerCase();
    return terms.some(function (term) { return text.indexOf(term) >= 0; });
  }

  function isTransparent(product) {
    return hasTransparency(product, ['clear', 'transparent', 'semi', 'tinted', 'opal']) || hasAny(product.text, ['transparent', 'clear', 'opal', 'opaal', 'translucent']);
  }

  function parseThickness(value) {
    var match = String(value || '').replace(',', '.').match(/(\d+(?:\.\d+)?)\s*mm/i);
    return match ? Number(match[1]) : NaN;
  }

  function sortThickness(a, b) {
    var aNumber = parseThickness(a);
    var bNumber = parseThickness(b);
    if (isFiniteNumber(aNumber) && isFiniteNumber(bNumber)) return aNumber - bNumber;
    return String(a).localeCompare(String(b));
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && isFinite(value);
  }

  function focusStepTitle(app) {
    var title = app.querySelector('[data-ma-focus]');
    if (title) title.focus({ preventScroll: true });
  }

  function track(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
  }

  function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  window.MaterialAdvisor = {
    initAll: initAll,
    initRoot: initRoot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-material-advisor]');
    if (root) initRoot(root);
  });
})();
